import {createContext} from 'react';

export const AllProductsContext = createContext(null);